export default [
  {
    path: '/finanzas_corporativas/CS-FORCATS/nominas',
    name: 'nominas',
    component: () => import('@/views/finanzas_corporativas/nominas.vue'),
    meta: {
      pageTitle: 'Nóminas',
      breadcrumb: [
        {
          text: 'Finanzas Corporativas',
        },
        {
          text: 'Cash Flow Forecast',
        },
        {
          text: 'Nóminas',
          active: true,
        },
      ],
      resource: 'Nominas',
      action: 'menu',
    },
  },
]
